<template>
  <StepLayout
    ref="stepRef"
    :title="$t(`components.passport.${typeKey}.title`)"
    :showBack="false"
    :withSearch="withSearch"
  >
    <template #button="{ isMobile }">
      <ActionButton
        :label="$t('components.buttons.clear_selection')"
        :hide="!property"
        :isMobile="isMobile"
        @click="clear"
      />
    </template>
    <Component
      :is="component"
      :initialState="initialState"
      :buildingId="item.tenant.id"
      :disabledItems="disabledItems"
      :query="stepRef?.query"
      @change="form[typeKey] = $event"
      @clear:query="stepRef?.clearQuery()"
    />
  </StepLayout>
</template>

<script setup>
import { computed, ref } from "vue";
import { useForm } from "@inertiajs/vue3";
import { Spaces, AssetGroups } from "@/SharedComponents/Modals/Content";
import { ActionButton, StepLayout } from "@/SharedComponents/Passport";
import { PropertyType } from "@/Composables/useProperties";

const emit = defineEmits(["back", "update"]);

const stepRef = ref(null);

const props = defineProps({
  item: { type: Object, required: true },
  typeKey: { type: String, required: true },
  withSearch: { type: Boolean, default: false },
  disabledItems: { type: Array, default: () => [] },
});

const property = computed(() => props.item[props.typeKey]);

const form = useForm({
  [props.typeKey]: property.value,
});

const component = computed(() => {
  switch (props.typeKey) {
    case PropertyType.SPACE:
      return Spaces;
    case PropertyType.ASSET_GROUP:
      return AssetGroups;
    default:
      return "div";
  }
});

const initialState = computed(() => {
  switch (props.typeKey) {
    case PropertyType.ASSET_GROUP:
      return property.value;
    default:
      return property.value?.id;
  }
});

function clear() {
  form[props.typeKey] = null;
  submit();
}

function cancel() {
  form.reset();
  emit("back");
}

function submit() {
  emit("update", {
    data: form.data(),
    callback: (success) => (success ? form.defaults() : form.reset()),
  });
  emit("back");
}

defineExpose({
  editing: true,
  isDirty: computed(() => form.isDirty),
  cancel,
  submit,
});
</script>
